import { SampleData } from "../../stores/Sample";
import { AlignmentOptions } from "../../stores/Search";
import { FeatureAnchor, SampleAnchor, SampleQuote } from "../PaperShared/Sample";
import { SamplesList } from "../SamplesList";

function Sample2032000() {
  const samplesList: SampleData[] = similarSamples.map(
    (sample) =>
      new SampleData(
        sample.sampleText,
        sample.decodedTokens,
        sample.activations,
        sample.normalizedActivations,
        sample.targetIdx,
        sample.absoluteTokenIdx,
        sample.modelId
      )
  );

  return (
    <section className="sample">
      <h4>
        <SampleAnchor modelId="mini" sampleId="2032000" />
        <span> - </span>
        <SampleQuote text="more than 100 birds and included" targetIdx={19} targetLength={4} />
      </h4>
      <p>
        To predict what may be included within a list of “100 birds”, this circuit uses Feature{" "}
        <FeatureAnchor modelId="mini" sampleId="2032000" featureKey="2.7.3103" compact />, which
        responds to facts about animals. This feature, through self-attention, depends upon Feature{" "}
        <FeatureAnchor modelId="mini" sampleId="2032000" featureKey="8.6.5617" compact />, which
        responds to words describing different types of animals, and Feature{" "}
        <FeatureAnchor modelId="mini" sampleId="2032000" featureKey="7.6.1465" compact />, which
        responds to words describing the classification of animals.
      </p>
      <figure>
        <figcaption>
          Activations for <FeatureAnchor modelId="mini" sampleId="2032000" featureKey="2.7.3103" />
        </figcaption>
        <SamplesList
          samples={samplesList}
          alignment={AlignmentOptions.Token}
          rightPadding={20}
          hideActivation={true}
          showIcon={true}
        />
      </figure>
    </section>
  );
}

const similarSamples = [
  {
    sampleText:
      " on the Upper Yukon, Mr. McQuesten secured a specimen of this bird on April 22, 1878, and Mr. Dall records it as a permanent resident at Nulato; but this, I am inclined to think, is somewhat doubtful, from statements made me by the fur traders and natives.\nCIRCUS HUDSONIUS - Marsh Hawk.\nThese hawks are numerous throughout Northern Alaska during the migrations. It is seen frequently along the barren coast of Bering Sea, and has been recorded as rather uncommon in the interior. The last of May, 1879, it was common at the Yukon mouth, and on May 6th a specimen was secured by Mr. McQuesten at Fort Reliance, on the upper part of this river.\nFALCO PEREGRINUS ANATUM - Duck Hawk. A single specimen of this widely ranging species was obtained by Mr. McQuesten on the Upper Yukon at Fort Reliance on September 10, 1878.\nDRYOBATES VILLOSUS LEUCOMELAS - Northern Hairy Woodpecker. This large form of the Hairy Woodpecker nests along the northern tier of States, particularly those bordering the Saint Lawrence,",
    decodedTokens: [
      " on",
      " the",
      " Upper",
      " Yuk",
      "on",
      ",",
      " Mr",
      ".",
      " Mc",
      "Quest",
      "en",
      " secured",
      " a",
      " specimen",
      " of",
      " this",
      " bird",
      " on",
      " April",
      " 22",
      ",",
      " 18",
      "78",
      ",",
      " and",
      " Mr",
      ".",
      " D",
      "all",
      " records",
      " it",
      " as",
      " a",
      " permanent",
      " resident",
      " at",
      " N",
      "ul",
      "ato",
      ";",
      " but",
      " this",
      ",",
      " I",
      " am",
      " inclined",
      " to",
      " think",
      ",",
      " is",
      " somewhat",
      " doubtful",
      ",",
      " from",
      " statements",
      " made",
      " me",
      " by",
      " the",
      " fur",
      " traders",
      " and",
      " natives",
      ".",
      "\n",
      "C",
      "IRC",
      "US",
      " H",
      "U",
      "DS",
      "ON",
      "I",
      "US",
      " -",
      " Marsh",
      " Hawk",
      ".",
      "\n",
      "These",
      " haw",
      "ks",
      " are",
      " numerous",
      " throughout",
      " Northern",
      " Alaska",
      " during",
      " the",
      " migr",
      "ations",
      ".",
      " It",
      " is",
      " seen",
      " frequently",
      " along",
      " the",
      " barren",
      " coast",
      " of",
      " B",
      "ering",
      " Sea",
      ",",
      " and",
      " has",
      " been",
      " recorded",
      " as",
      " rather",
      " uncommon",
      " in",
      " the",
      " interior",
      ".",
      " The",
      " last",
      " of",
      " May",
      ",",
      " 18",
      "79",
      ",",
      " it",
      " was",
      " common",
      " at",
      " the",
      " Yuk",
      "on",
      " mouth",
      ",",
      " and",
      " on",
      " May",
      " 6",
      "th",
      " a",
      " specimen",
      " was",
      " secured",
      " by",
      " Mr",
      ".",
      " Mc",
      "Quest",
      "en",
      " at",
      " Fort",
      " Rel",
      "iance",
      ",",
      " on",
      " the",
      " upper",
      " part",
      " of",
      " this",
      " river",
      ".",
      "\n",
      "F",
      "AL",
      "CO",
      " PER",
      "EG",
      "R",
      "IN",
      "US",
      " AN",
      "AT",
      "UM",
      " -",
      " Duck",
      " Hawk",
      ".",
      " A",
      " single",
      " specimen",
      " of",
      " this",
      " widely",
      " ranging",
      " species",
      " was",
      " obtained",
      " by",
      " Mr",
      ".",
      " Mc",
      "Quest",
      "en",
      " on",
      " the",
      " Upper",
      " Yuk",
      "on",
      " at",
      " Fort",
      " Rel",
      "iance",
      " on",
      " September",
      " 10",
      ",",
      " 18",
      "78",
      ".",
      "\n",
      "DR",
      "Y",
      "OB",
      "ATES",
      " V",
      "ILL",
      "OS",
      "US",
      " LE",
      "UC",
      "OM",
      "EL",
      "AS",
      " -",
      " Northern",
      " H",
      "airy",
      " Wood",
      "pe",
      "cker",
      ".",
      " This",
      " large",
      " form",
      " of",
      " the",
      " H",
      "airy",
      " Wood",
      "pe",
      "cker",
      " nests",
      " along",
      " the",
      " northern",
      " tier",
      " of",
      " States",
      ",",
      " particularly",
      " those",
      " bordering",
      " the",
      " Saint",
      " Lawrence",
      ",",
    ],
    activations: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.407, 0.443, 0.464, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0.609, 0.727, 0.526, 0.64, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.246, 0, 0, 0, 0, 0, 0, 0, 0, 0.384, 0.694, 0.843, 0.355,
      0, 0.482, 0.677, 0.866, 1.102, 0.464, 0.557, 0.295, 0, 0.427, 0.542, 0, 0.336, 0.751, 0.596,
      0.396, 0.511, 0.37, 0.429, 0.399, 0, 0, 0.206, 0, 0, 0.318, 0.233, 0.437, 0.582, 0.34, 0.605,
      0.789, 0.657, 0.611, 0.536, 0.352, 0.219, 0.594, 0.943, 0.715, 0.573, 0.269, 0, 0, 0, 0,
      0.264, 0.291, 0, 0.244, 0.208, 0, 0, 0, 0, 0.252, 0, 0, 0, 0, 0.459, 0.541, 0.391, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.233, 0, 0.213, 0.284, 0.309, 0, 0, 0, 0, 0, 0, 0.281,
      0.325, 0, 0, 0.837, 0.748, 0.995, 0.518, 1.023, 0.976, 0.54, 1.265, 1.471, 1.011, 1.515,
      0.656, 0.265, 0, 0.233, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.291,
      0.319, 0, 0, 0, 0.238, 0, 0, 0, 0.336, 0, 0, 0, 0, 0, 1.032, 0.835, 0.544, 1.397, 1.126,
      0.644, 1.089, 0.575, 1.373, 1.758, 0.734, 1.527, 1.456, 0.839, 1.432, 1.176, 0.613, 0.938,
      0.558, 0.733, 0.411, 0, 0, 0.673, 0, 0.232, 0.285, 0, 0.258, 0.336, 0, 0, 0,
    ],
    normalizedActivations: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.23155707734158343, 0.2520387844283083,
      0.26398644689556444, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.3464822115504283,
      0.4136166958902485, 0.29926049798936827, 0.36411923709733024, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.1399583317592863, 0, 0, 0, 0, 0, 0,
      0, 0, 0.21847154225839815, 0.39484179772741745, 0.4796133076141396, 0.20197238932742534, 0,
      0.27422730043892685, 0.38516988049201967, 0.49269884269732495, 0.6269678113769656,
      0.26398644689556444, 0.31689752353627026, 0.16783621084955064, 0, 0.242935803500875,
      0.30836347891680155, 0, 0.19116259947609837, 0.42727116728139847, 0.33908603954688876,
      0.2252987779539731, 0.2907264533698996, 0.21050643394689403, 0.24407367611680417,
      0.22700558687786682, 0, 0, 0.11720087944070316, 0, 0, 0.18092174593273597,
      0.13256215975574678, 0.2486251665805208, 0.33112093123538466, 0.1934383447079567,
      0.34420646631857, 0.44889074698405246, 0.3737911543327281, 0.3476200841663574,
      0.30494986106901406, 0.20026558040353162, 0.12459705144424268, 0.3379481669309596,
      0.5365069384105975, 0.4067894601946736, 0.32600050446370343, 0.15304386684247162, 0, 0, 0, 0,
      0.15019918530264872, 0.16556046561769233, 0, 0.13882045914335714, 0.11833875205663232, 0, 0,
      0, 0, 0.14337194960707378, 0, 0, 0, 0, 0.2611417653557415, 0.307794542608837,
      0.2224540964141502, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.13256215975574678, 0,
      0.12118343359645521, 0.16157791146194028, 0.17580131916105474, 0, 0, 0, 0, 0, 0,
      0.15987110253804657, 0.18490430008848802, 0, 0, 0.4761996897663522, 0.4255643583575047,
      0.5660916264247556, 0.29470900752565166, 0.5820218430477637, 0.5552818365734286,
      0.3072256063008724, 0.7197044295751918, 0.836905309015895, 0.5751946073521887,
      0.8619385065663363, 0.3732222180247635, 0.15076812161061331, 0, 0.13256215975574678, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.16556046561769233, 0.18149068224070053,
      0, 0, 0, 0.13540684129556968, 0, 0, 0, 0.19116259947609837, 0, 0, 0, 0, 0, 0.5871422698194451,
      0.475061817150423, 0.30950135153273073, 0.7948040222265161, 0.6406222827681153,
      0.36639498232918855, 0.619571639373426, 0.3271383770796326, 0.7811495508353663,
      1.000190029401729, 0.4175992500460006, 0.8687657422619113, 0.8283712643964263,
      0.4773375623822813, 0.8147167930052763, 0.6690690981663443, 0.3487579567822866,
      0.5336622568707746, 0.3174664598442348, 0.417030313738036, 0.23383282257344173, 0, 0,
      0.38289413526016136, 0, 0.13199322344778222, 0.16214684776990484, 0, 0.14678556745486127,
      0.19116259947609837, 0, 0, 0,
    ],
    targetIdx: 232,
    absoluteTokenIdx: 6802408,
    modelId: "mini",
  },
  {
    sampleText:
      " that grow. The topography of a savanna grassland includes the landscape. The landscape includes hills and prairies, rocks, cliffs, gullies and low-lying areas. The natural disturbances that occur in a savanna grassland include flooding from rivers and streams and fires from lightning storms. There are many different species of plants and animals that make up the biotic component of the savanna grassland.\nAnimal depends on each other to keep the savanna grassland ecosystem in equilibrium. Most animals in the grassland savanna are long-legged or have wings in order to migrate. In addition, there are many animals that burrow to avoid heat and protect their young. There are also many predator birds such as hawks due to the wide open plains that provide a clear view of prey. Plants in a savanna grassland are specialized to survive long droughts. These types of plants have long tap roots to reach water, thick bark to protect from fires and trunks to store water.\nUniversity/College: University of California\nType of paper: Thesis/Dissertation Chapter\nDate: 28 October 2016\nWe will write a custom essay sample on Abiotic and Biotic\nfor only $16.38 $13.9/page<|endoftext|>",
    decodedTokens: [
      " that",
      " grow",
      ".",
      " The",
      " top",
      "ography",
      " of",
      " a",
      " sav",
      "anna",
      " grass",
      "land",
      " includes",
      " the",
      " landscape",
      ".",
      " The",
      " landscape",
      " includes",
      " hills",
      " and",
      " pra",
      "iries",
      ",",
      " rocks",
      ",",
      " cliffs",
      ",",
      " gull",
      "ies",
      " and",
      " low",
      "-",
      "lying",
      " areas",
      ".",
      " The",
      " natural",
      " disturbances",
      " that",
      " occur",
      " in",
      " a",
      " sav",
      "anna",
      " grass",
      "land",
      " include",
      " flooding",
      " from",
      " rivers",
      " and",
      " streams",
      " and",
      " fires",
      " from",
      " lightning",
      " storms",
      ".",
      " There",
      " are",
      " many",
      " different",
      " species",
      " of",
      " plants",
      " and",
      " animals",
      " that",
      " make",
      " up",
      " the",
      " bi",
      "otic",
      " component",
      " of",
      " the",
      " sav",
      "anna",
      " grass",
      "land",
      ".",
      "\n",
      "Animal",
      " depends",
      " on",
      " each",
      " other",
      " to",
      " keep",
      " the",
      " sav",
      "anna",
      " grass",
      "land",
      " ecosystem",
      " in",
      " equilibrium",
      ".",
      " Most",
      " animals",
      " in",
      " the",
      " grass",
      "land",
      " sav",
      "anna",
      " are",
      " long",
      "-",
      "legged",
      " or",
      " have",
      " wings",
      " in",
      " order",
      " to",
      " migrate",
      ".",
      " In",
      " addition",
      ",",
      " there",
      " are",
      " many",
      " animals",
      " that",
      " bur",
      "row",
      " to",
      " avoid",
      " heat",
      " and",
      " protect",
      " their",
      " young",
      ".",
      " There",
      " are",
      " also",
      " many",
      " predator",
      " birds",
      " such",
      " as",
      " haw",
      "ks",
      " due",
      " to",
      " the",
      " wide",
      " open",
      " plains",
      " that",
      " provide",
      " a",
      " clear",
      " view",
      " of",
      " prey",
      ".",
      " Plants",
      " in",
      " a",
      " sav",
      "anna",
      " grass",
      "land",
      " are",
      " specialized",
      " to",
      " survive",
      " long",
      " d",
      "rough",
      "ts",
      ".",
      " These",
      " types",
      " of",
      " plants",
      " have",
      " long",
      " tap",
      " roots",
      " to",
      " reach",
      " water",
      ",",
      " thick",
      " bark",
      " to",
      " protect",
      " from",
      " fires",
      " and",
      " tr",
      "unks",
      " to",
      " store",
      " water",
      ".",
      "\n",
      "University",
      "/",
      "College",
      ":",
      " University",
      " of",
      " California",
      "\n",
      "Type",
      " of",
      " paper",
      ":",
      " The",
      "sis",
      "/",
      "D",
      "iss",
      "ertation",
      " Chapter",
      "\n",
      "Date",
      ":",
      " 28",
      " October",
      " 2016",
      "\n",
      "We",
      " will",
      " write",
      " a",
      " custom",
      " essay",
      " sample",
      " on",
      " Ab",
      "iotic",
      " and",
      " B",
      "iotic",
      "\n",
      "for",
      " only",
      " $",
      "16",
      ".",
      "38",
      " $",
      "13",
      ".",
      "9",
      "/",
      "page",
      "<|endoftext|>",
    ],
    activations: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.228, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.402, 0, 0, 0, 0, 0, 0.243, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0.596, 0.944, 0.521, 0.662, 0.664, 0.663, 0.247, 0, 0.27, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0.221, 0, 0.449, 0, 0.38, 0.365, 0, 0, 0, 0.232, 0, 0, 0, 0, 0, 0, 0, 0, 0.314, 0.277,
      0.385, 0.51, 0, 0.273, 0, 0.247, 0.615, 0.512, 0.506, 0.982, 0.957, 0.795, 0, 0.433, 0, 0.772,
      0.52, 0.428, 0.405, 0, 0.63, 0.267, 0.493, 0.679, 0.65, 0.853, 0.423, 0.336, 0.493, 0.395, 0,
      0, 0.46, 0.576, 0.299, 0.37, 0.208, 0.513, 0.695, 0.789, 0.974, 0.941, 0.92, 1.721, 0.754,
      1.042, 0.326, 0.88, 1.009, 1.019, 0.539, 0.359, 0.565, 0.717, 0.59, 0, 0, 0.555, 0.455, 0.547,
      0.309, 0.319, 0.461, 0, 0, 0, 0.341, 0.35, 0.328, 0.678, 0.329, 0, 0, 0, 0, 0.305, 0.375, 0,
      0.466, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.361, 0, 0, 0, 0, 0, 0, 0, 0, 0.233, 0.306, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0.341, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    normalizedActivations: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.1297174782159239, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0.22871239580176056, 0, 0, 0, 0, 0, 0.13825152283539258, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.33908603954688876, 0.5370758747185621,
      0.2964158164495454, 0.37663583587255095, 0.37777370848848013, 0.37720477218051557,
      0.14052726806725088, 0, 0.1536128031504362, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.12573492406017184, 0,
      0.2554524022760957, 0, 0.21619579702653982, 0.20766175240707113, 0, 0, 0, 0.13199322344778222,
      0, 0, 0, 0, 0, 0, 0, 0, 0.17864600070087763, 0.15759535730618826, 0.21904047856636272,
      0.29015751706193504, 0, 0.15531961207432993, 0, 0.14052726806725088, 0.3498958293982158,
      0.29129538967786417, 0.28788177183007674, 0.558695454421216, 0.5444720467221016,
      0.4523043648318399, 0, 0.24634942134866247, 0, 0.4392188297486546, 0.29584688014158084,
      0.24350473980883958, 0.2304192047256543, 0, 0.35842987401768445, 0.15190599422654247,
      0.2804855998265372, 0.3863077531079488, 0.36980860017697603, 0.4853026706937854,
      0.24066005826901668, 0.19116259947609837, 0.2804855998265372, 0.2247298416460085, 0, 0,
      0.26171070166370614, 0.3277073133875972, 0.17011195608140897, 0.21050643394689403,
      0.11833875205663232, 0.2918643259858288, 0.395410734035382, 0.44889074698405246,
      0.5541439639574994, 0.5353690657946684, 0.5234214033274123, 0.9791393860070396,
      0.42897797620529216, 0.5928316328990908, 0.18547323639645258, 0.5006639510088291,
      0.5740567347362596, 0.5797460978159055, 0.3066566699929078, 0.20424813455928367,
      0.3214490139999868, 0.4079273328106027, 0.3356724216991013, 0, 0, 0.3157596509203411,
      0.2588660201238832, 0.31120816045662447, 0.17580131916105474, 0.18149068224070053,
      0.2622796379716707, 0, 0, 0, 0.19400728101592127, 0.19912770778760244, 0.18661110901238176,
      0.38573881679998423, 0.18718004532034632, 0, 0, 0, 0, 0.17352557392919643,
      0.21335111548671692, 0, 0.26512431951149357, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.20538600717521283, 0, 0, 0, 0, 0, 0, 0, 0, 0.13256215975574678, 0.17409451023716102, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0.19400728101592127, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    targetIdx: 144,
    absoluteTokenIdx: 9273232,
    modelId: "mini",
  },
  {
    sampleText:
      " of small mammals and 170 species\nof birds have been seen at the Preserve in the spring.\nThe preserve itself consists of three\nsections divided by major roads, with trails that meander\nthrough each part. In the southern section, between Merrick Road\nand Sunrise Highway, the preserve is host to the largest\nAtlantic White Cedar “stand,” or grouping of trees, in Nassau\nCounty, located in a swamp just north of Tackapausha Pond, near\nIn the central section, between Sunrise\nHighway and Clark Avenue, a small, secluded pond draws waterfowl\nand amphibians. The northern section, between Clark and\nJerusalem avenues, includes a small wetland near Clark.\nBird-watchers often hike the trails, with\nlawn chairs in tow, seeking out species commonly found at the\npreserve, such as the ruby-throated humming bird. In all, more\nthan 170 bird species have been identified within the preserve,\nalong with raccoon, muskrat, gray squirrel and opossum.\nIn August 2010, the museum was closed for a\n$300,000 renovation and was set to open in January 2012, But it\nremained closed do",
    decodedTokens: [
      " of",
      " small",
      " mammals",
      " and",
      " 170",
      " species",
      "\n",
      "of",
      " birds",
      " have",
      " been",
      " seen",
      " at",
      " the",
      " Pres",
      "erve",
      " in",
      " the",
      " spring",
      ".",
      "\n",
      "The",
      " preserve",
      " itself",
      " consists",
      " of",
      " three",
      "\n",
      "sections",
      " divided",
      " by",
      " major",
      " roads",
      ",",
      " with",
      " trails",
      " that",
      " me",
      "ander",
      "\n",
      "through",
      " each",
      " part",
      ".",
      " In",
      " the",
      " southern",
      " section",
      ",",
      " between",
      " Mer",
      "rick",
      " Road",
      "\n",
      "and",
      " Sunrise",
      " Highway",
      ",",
      " the",
      " preserve",
      " is",
      " host",
      " to",
      " the",
      " largest",
      "\n",
      "Atlantic",
      " White",
      " Cedar",
      "\\x20\\xe2\\x80",
      "\\x9c",
      "stand",
      ",",
      "\\xe2\\x80",
      "\\x9d",
      " or",
      " grouping",
      " of",
      " trees",
      ",",
      " in",
      " Nass",
      "au",
      "\n",
      "Count",
      "y",
      ",",
      " located",
      " in",
      " a",
      " swamp",
      " just",
      " north",
      " of",
      " T",
      "ack",
      "apa",
      "usha",
      " Pond",
      ",",
      " near",
      "\n",
      "In",
      " the",
      " central",
      " section",
      ",",
      " between",
      " Sunrise",
      "\n",
      "High",
      "way",
      " and",
      " Clark",
      " Avenue",
      ",",
      " a",
      " small",
      ",",
      " se",
      "cluded",
      " pond",
      " draws",
      " water",
      "f",
      "owl",
      "\n",
      "and",
      " amphib",
      "ians",
      ".",
      " The",
      " northern",
      " section",
      ",",
      " between",
      " Clark",
      " and",
      "\n",
      "Jer",
      "usalem",
      " avenues",
      ",",
      " includes",
      " a",
      " small",
      " wet",
      "land",
      " near",
      " Clark",
      ".",
      "\n",
      "Bird",
      "-",
      "wat",
      "chers",
      " often",
      " hike",
      " the",
      " trails",
      ",",
      " with",
      "\n",
      "l",
      "awn",
      " chairs",
      " in",
      " tow",
      ",",
      " seeking",
      " out",
      " species",
      " commonly",
      " found",
      " at",
      " the",
      "\n",
      "pres",
      "erve",
      ",",
      " such",
      " as",
      " the",
      " ruby",
      "-",
      "thro",
      "ated",
      " humming",
      " bird",
      ".",
      " In",
      " all",
      ",",
      " more",
      "\n",
      "than",
      " 170",
      " bird",
      " species",
      " have",
      " been",
      " identified",
      " within",
      " the",
      " preserve",
      ",",
      "\n",
      "along",
      " with",
      " rac",
      "coon",
      ",",
      " mus",
      "k",
      "rat",
      ",",
      " gray",
      " squirrel",
      " and",
      " op",
      "oss",
      "um",
      ".",
      "\n",
      "In",
      " August",
      " 2010",
      ",",
      " the",
      " museum",
      " was",
      " closed",
      " for",
      " a",
      "\n",
      "$",
      "300",
      ",",
      "000",
      " renovation",
      " and",
      " was",
      " set",
      " to",
      " open",
      " in",
      " January",
      " 2012",
      ",",
      " But",
      " it",
      "\n",
      "rem",
      "ained",
      " closed",
      " do",
    ],
    activations: [
      0, 0, 0.296, 0.872, 0.952, 0.517, 0, 0.919, 0.359, 0.204, 0.233, 0.586, 0.226, 0, 0, 0, 0, 0,
      0, 0.278, 0, 0.466, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.301, 0, 0, 0, 0.587, 0.517, 0.594, 0.268, 0.543, 0.828,
      0.496, 0, 0.486, 0, 0.271, 0, 0.413, 0.541, 0, 0.589, 0, 0.536, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.257, 0.285,
      0.263, 0, 0, 0, 0, 0, 0, 0.755, 0.413, 1.195, 0.586, 0.585, 0.258, 0.303, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0.21, 0, 0.301, 0, 0, 0, 0, 0, 0, 0.719, 1.054, 0, 0.45, 0.372, 0.512, 0.346, 0,
      0.355, 0.383, 0.272, 0, 0.45, 0, 0, 0, 0, 0.292, 0.703, 1.011, 0.893, 0.632, 0.36, 0.353, 0,
      0, 0, 0.521, 0.196, 1.71, 1.655, 0.927, 0.544, 0, 1.343, 0.65, 1.024, 0.497, 0.232, 0.242,
      0.525, 0.429, 0, 0, 1, 0.75, 0.734, 0.496, 0.648, 0.302, 0.39, 0.361, 0, 0.356, 0, 0, 0.639,
      0.666, 1.049, 1.403, 0.708, 0.438, 0.857, 1.455, 0.832, 0.419, 1.473, 0.384, 0, 0.942, 0.423,
      0.277, 0.25, 0, 0, 0.227, 0.359, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0,
    ],
    normalizedActivations: [
      0, 0, 0.16840514715751523, 0.49611246054511243, 0.5416273651822787, 0.2941400712176871, 0,
      0.5228524670194477, 0.20424813455928367, 0.11606300682477401, 0.13256215975574678,
      0.33339667646724297, 0.12857960559999473, 0, 0, 0, 0, 0, 0, 0.15816429361415282, 0,
      0.26512431951149357, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.17124982869733812, 0, 0, 0, 0.33396561277520753,
      0.2941400712176871, 0.3379481669309596, 0.15247493053450703, 0.3089324152247661,
      0.47107926299467096, 0.28219240875043095, 0, 0.27650304567078515, 0, 0.15418173945840077, 0,
      0.2349706951893709, 0.307794542608837, 0, 0.3351034853911367, 0, 0.30494986106901406, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0.14621663114689668, 0.16214684776990484, 0.14963024899468413, 0, 0, 0, 0, 0, 0,
      0.4295469125132568, 0.2349706951893709, 0.6798788880176713, 0.33339667646724297,
      0.3328277401592784, 0.14678556745486127, 0.17238770131326728, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.11947662467256148, 0, 0.17124982869733812, 0, 0, 0, 0, 0, 0, 0.4090652054265319,
      0.5996588685946658, 0, 0.25602133858406034, 0.21164430656282318, 0.29129538967786417,
      0.19685196255574414, 0, 0.20197238932742534, 0.21790260595043356, 0.15475067576636536, 0,
      0.25602133858406034, 0, 0, 0, 0, 0.1661294019256569, 0.39996222449909863, 0.5751946073521887,
      0.5080601230123686, 0.3595677466336136, 0.20481707086724824, 0.20083451671149619, 0, 0, 0,
      0.2964158164495454, 0.11151151636105738, 0.9728810866194292, 0.9415895896813774,
      0.5274039574831643, 0.30950135153273073, 0, 0.7640814615964289, 0.36980860017697603,
      0.5825907793557283, 0.2827613450583955, 0.13199322344778222, 0.13768258652742799,
      0.2986915616814037, 0.24407367611680417, 0, 0, 0.5689363079645785, 0.42670223097343385,
      0.4175992500460006, 0.28219240875043095, 0.36867072756104685, 0.1718187650053027,
      0.2218851601061856, 0.20538600717521283, 0, 0.20254132563538993, 0, 0, 0.3635503007893657,
      0.3789115811044093, 0.5968141870548428, 0.7982176400743036, 0.40280690603892155,
      0.24919410288848537, 0.48757841592564377, 0.8278023280884618, 0.47335500822652926,
      0.23838431303715837, 0.8380431816318241, 0.21847154225839815, 0, 0.5359380021026329,
      0.24066005826901668, 0.15759535730618826, 0.14223407699114463, 0, 0, 0.12914854190795932,
      0.20424813455928367, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0,
    ],
    targetIdx: 181,
    absoluteTokenIdx: 2415029,
    modelId: "mini",
  },
  {
    sampleText:
      " m) in length.\nMature males have been taken at lengths of 2.5-4 feet (0.77-1.21 m) and mature females have measured 3.8-5.2 feet\nKitefin sharks have large serrate teeth and powerful jaws\n© George Burgess\n- · Food Habits\n- Kitefin sharks are formidable solitary predators with large, serrate teeth and powerful jaws.\nThey consume a variety of small deepwater fishes, skates, and sharks; squids and octopods; shrimps and lobsters;\nisopods and amphipods; siphonophores; and polychaetes. Fishes make up the majority of their diet.\nKitefin shark embryos\n© Doug Perrine\n- · Reproduction\n- Reproduction of the kitefin shark takes place via ovoviviparity. A total\nof 10-16 young are born with each measuring about 12 inches (30 cm) in length.\n- · Predators\n- Potential predators include large fish and sharks residing in the same habitats and depths\nas the kitefin shark.\n- · Parasites\n- There are no available detailed studies on parasites of the kitefin shark.",
    decodedTokens: [
      " m",
      ")",
      " in",
      " length",
      ".",
      "\n",
      "M",
      "ature",
      " males",
      " have",
      " been",
      " taken",
      " at",
      " lengths",
      " of",
      " 2",
      ".",
      "5",
      "-",
      "4",
      " feet",
      " (",
      "0",
      ".",
      "77",
      "-",
      "1",
      ".",
      "21",
      " m",
      ")",
      " and",
      " mature",
      " females",
      " have",
      " measured",
      " 3",
      ".",
      "8",
      "-",
      "5",
      ".",
      "2",
      " feet",
      "\n",
      "K",
      "ite",
      "fin",
      " sharks",
      " have",
      " large",
      " ser",
      "rate",
      " teeth",
      " and",
      " powerful",
      " jaws",
      "\n",
      "©",
      " George",
      " Burgess",
      "\n",
      "-",
      " ·",
      " Food",
      " Hab",
      "its",
      "\n",
      "-",
      " K",
      "ite",
      "fin",
      " sharks",
      " are",
      " formidable",
      " solitary",
      " predators",
      " with",
      " large",
      ",",
      " ser",
      "rate",
      " teeth",
      " and",
      " powerful",
      " jaws",
      ".",
      "\n",
      "They",
      " consume",
      " a",
      " variety",
      " of",
      " small",
      " deep",
      "water",
      " fishes",
      ",",
      " sk",
      "ates",
      ",",
      " and",
      " sharks",
      ";",
      " squ",
      "ids",
      " and",
      " oct",
      "op",
      "ods",
      ";",
      " sh",
      "rim",
      "ps",
      " and",
      " lob",
      "sters",
      ";",
      "\n",
      "is",
      "op",
      "ods",
      " and",
      " amph",
      "ip",
      "ods",
      ";",
      " siph",
      "on",
      "oph",
      "ores",
      ";",
      " and",
      " poly",
      "cha",
      "et",
      "es",
      ".",
      " F",
      "ishes",
      " make",
      " up",
      " the",
      " majority",
      " of",
      " their",
      " diet",
      ".",
      "\n",
      "K",
      "ite",
      "fin",
      " shark",
      " embryos",
      "\n",
      "©",
      " Doug",
      " Per",
      "rine",
      "\n",
      "-",
      " ·",
      " Reprodu",
      "ction",
      "\n",
      "-",
      " Reprodu",
      "ction",
      " of",
      " the",
      " k",
      "ite",
      "fin",
      " shark",
      " takes",
      " place",
      " via",
      " ov",
      "ov",
      "iv",
      "ip",
      "arity",
      ".",
      " A",
      " total",
      "\n",
      "of",
      " 10",
      "-",
      "16",
      " young",
      " are",
      " born",
      " with",
      " each",
      " measuring",
      " about",
      " 12",
      " inches",
      " (",
      "30",
      " cm",
      ")",
      " in",
      " length",
      ".",
      "\n",
      "-",
      " ·",
      " Predators",
      "\n",
      "-",
      " Potential",
      " predators",
      " include",
      " large",
      " fish",
      " and",
      " sharks",
      " residing",
      " in",
      " the",
      " same",
      " habitats",
      " and",
      " depths",
      "\n",
      "as",
      " the",
      " k",
      "ite",
      "fin",
      " shark",
      ".",
      "\n",
      "-",
      " ·",
      " Paras",
      "ites",
      "\n",
      "-",
      " There",
      " are",
      " no",
      " available",
      " detailed",
      " studies",
      " on",
      " parasites",
      " of",
      " the",
      " k",
      "ite",
      "fin",
      " shark",
      ".",
    ],
    activations: [
      0, 0, 0, 0, 0.19, 0, 0.225, 0.696, 0.659, 0.769, 0.62, 0.397, 0.392, 0, 0.236, 0.376, 0,
      0.369, 0, 0, 0, 0.274, 0, 0, 0, 0, 0, 0, 0.289, 0, 0.26, 0.626, 0.968, 0.538, 0.49, 0.378,
      0.33, 0, 0, 0, 0.24, 0, 0.264, 0, 0.317, 0, 0.512, 0.834, 0.63, 0.745, 1.146, 0.531, 0.575, 0,
      0.682, 0.884, 0, 0.173, 0, 0, 0, 0.276, 0.448, 0.223, 0, 0, 0, 0, 0, 0, 0.508, 0.78, 0.519,
      0.717, 1.016, 1.115, 0.66, 0.877, 1.248, 0.843, 0, 0.793, 0, 0.784, 0.927, 0.237, 0.464, 0,
      0.787, 0.65, 0.452, 0, 0.576, 0.965, 0.526, 0.954, 0.49, 0.866, 0.495, 0.668, 1.205, 1.158,
      0.38, 0.834, 0.485, 0.642, 1.226, 0.942, 0, 0.637, 1.087, 0.779, 0, 0.863, 0.899, 0.458,
      0.343, 1.01, 0.325, 0.74, 0, 0.554, 1.004, 0.765, 0.35, 0.404, 0.836, 0, 0.571, 0.413, 0,
      0.728, 0.752, 0.574, 0, 0.279, 0.283, 0.468, 0.314, 0.42, 0.376, 0, 0.429, 0.325, 0.674,
      0.607, 0.374, 0.609, 0.317, 0, 0, 0.8, 0.758, 0, 0, 0, 0, 0, 0, 0, 0, 0.334, 0, 0.324, 0, 0,
      0, 0.316, 0.638, 0.711, 0.405, 0.372, 0.628, 0.496, 0, 0, 0.307, 0, 0, 0, 0, 0, 0.212, 0.34,
      0, 0, 0, 0.488, 0, 0.476, 0.393, 0.38, 0.327, 0.28, 0.318, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.259, 0, 0, 0.539, 0.945, 0.367, 0, 0.542, 0.463, 1.654, 1.705, 1.157, 1.481, 0.645, 0.665,
      0.844, 0.873, 0.62, 0, 0.708, 0, 0, 0.462, 0.911, 0, 0.495, 1.058, 1.125, 0.651, 0, 0, 1.064,
      0.31, 0.405, 0, 0, 0.32, 0.407, 0.538, 0.332, 0, 0, 0.643, 0.395, 0.786, 1.002, 0, 0.339,
      0.703, 0.666, 0.236,
    ],
    normalizedActivations: [
      0, 0, 0, 0, 0.10809789851326991, 0, 0.12801066929203017, 0.3959796703433466,
      0.37492902694865726, 0.43751202082476087, 0.35274051093803865, 0.22586771426193766,
      0.22302303272211477, 0, 0.13426896867964053, 0.21392005179468151, 0, 0.20993749763892947, 0,
      0, 0, 0.15588854838229452, 0, 0, 0, 0, 0, 0, 0.16442259300176318, 0, 0.14792344007079042,
      0.35615412878582614, 0.5507303461097119, 0.30608773368494324, 0.27877879090264346,
      0.21505792441061067, 0.1877489816283109, 0, 0, 0, 0.13654471391149883, 0, 0.15019918530264872,
      0, 0.18035280962477138, 0, 0.29129538967786417, 0.47449288084245844, 0.35842987401768445,
      0.423857549433611, 0.6520010089274069, 0.3021051795291912, 0.3271383770796326, 0,
      0.38801456203184254, 0.5029396962406874, 0, 0.09842598127787207, 0, 0, 0, 0.15702642099822367,
      0.25488346596813116, 0.126872796676101, 0, 0, 0, 0, 0, 0, 0.28901964444600586,
      0.4437703202123712, 0.2952779438336162, 0.4079273328106027, 0.5780392888920117,
      0.634363983380505, 0.3754979632566218, 0.49895714208493536, 0.7100325123397939,
      0.4796133076141396, 0, 0.45116649221591076, 0, 0.44604606544422953, 0.5274039574831643,
      0.1348379049876051, 0.26398644689556444, 0, 0.4477528743681233, 0.36980860017697603,
      0.25715921119998947, 0, 0.3277073133875972, 0.5490235371858182, 0.29926049798936827,
      0.5427652377982078, 0.27877879090264346, 0.49269884269732495, 0.2816234724424663,
      0.38004945372033844, 0.6855682510973171, 0.6588282446229818, 0.21619579702653982,
      0.47449288084245844, 0.27593410936282053, 0.3652571097132594, 0.6975159135645732,
      0.5359380021026329, 0, 0.3624124281734365, 0.6184337667574968, 0.44320138390440666, 0,
      0.4909920337734312, 0.5114737408601561, 0.26057282904777695, 0.19514515363185042,
      0.5746256710442242, 0.18490430008848802, 0.42101286789378806, 0, 0.3151907146123765,
      0.5712120531964368, 0.43523627559290257, 0.19912770778760244, 0.2298502684176897,
      0.47563075345838757, 0, 0.3248626318477743, 0.2349706951893709, 0, 0.41418563219821314,
      0.42784010358936303, 0.326569440771668, 0, 0.1587332299221174, 0.1610089751539757,
      0.26626219212742275, 0.17864600070087763, 0.23895324934512296, 0.21392005179468151, 0,
      0.24407367611680417, 0.18490430008848802, 0.3834630715681259, 0.3453443389344991,
      0.21278217917875236, 0.3464822115504283, 0.18035280962477138, 0, 0, 0.4551490463716628,
      0.4312537214371505, 0, 0, 0, 0, 0, 0, 0, 0, 0.19002472686016922, 0, 0.18433536378052343, 0, 0,
      0, 0.1797838733168068, 0.36298136448140106, 0.4045137149628153, 0.2304192047256543,
      0.21164430656282318, 0.35729200140175527, 0.28219240875043095, 0, 0, 0.17466344654512558, 0,
      0, 0, 0, 0, 0.12061449728849064, 0.1934383447079567, 0, 0, 0, 0.2776409182867143, 0,
      0.27081368259113936, 0.22359196903007936, 0.21619579702653982, 0.18604217270441717,
      0.15930216623008198, 0.18092174593273597, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.14735450376282583,
      0, 0, 0.3066566699929078, 0.5376448110265266, 0.2087996250230003, 0, 0.30836347891680155,
      0.2634175105875998, 0.9410206533734128, 0.9700364050796063, 0.6582593083150173,
      0.8425946720955407, 0.3669639186371531, 0.3783426447964447, 0.48018224392210423,
      0.496681396853077, 0.35274051093803865, 0, 0.40280690603892155, 0, 0, 0.26284857427963526,
      0.518300976555731, 0, 0.2816234724424663, 0.601934613826524, 0.6400533464601508,
      0.3703775364849406, 0, 0, 0.6053482316743115, 0.17637025546901933, 0.2304192047256543, 0, 0,
      0.18205961854866512, 0.23155707734158343, 0.30608773368494324, 0.18888685424424007, 0, 0,
      0.365826046021224, 0.2247298416460085, 0.4471839380601587, 0.5700741805805076, 0,
      0.19286940839999211, 0.39996222449909863, 0.3789115811044093, 0.13426896867964053,
    ],
    targetIdx: 215,
    absoluteTokenIdx: 387799,
    modelId: "mini",
  },
  {
    sampleText:
      "aphne Major – A small island directly north of Santa Cruz and directly west of Baltra, this very inaccessible island appears, though unnamed, on Ambrose Cowley's 1684 chart. It is important as the location of multidecade finch population studies by Peter and Rosemary Grant.\n- South Plaza Island (Plaza Sur) – It is named in honor of a former president of Ecuador, General Leonidas Plaza. It has an area of 0.13 km2 (0.05 sq mi) and a maximum altitude of 23 m (75 ft). The flora of South Plaza includes Opuntia cactus and Sesuvium plants, which form a reddish carpet on top of the lava formations. Iguanas (land, marine and some hybrids of both species) are abundant, and large numbers of birds can be observed from the cliffs at the southern part of the island, including tropic birds and swallow-tailed gulls.\n- Nameless Island – A small islet used mostly for scuba diving.\n- Roca Redonda – An islet approximately 25 km (16 mi) northwest of Isabela. Herman Melville devotes the third and fourth sketches of The Encantadas to describing this islet (which he calls \"",
    decodedTokens: [
      "aph",
      "ne",
      " Major",
      " –",
      " A",
      " small",
      " island",
      " directly",
      " north",
      " of",
      " Santa",
      " Cruz",
      " and",
      " directly",
      " west",
      " of",
      " Balt",
      "ra",
      ",",
      " this",
      " very",
      " inaccessible",
      " island",
      " appears",
      ",",
      " though",
      " unnamed",
      ",",
      " on",
      " Ambrose",
      " Cow",
      "ley",
      "'s",
      " 16",
      "84",
      " chart",
      ".",
      " It",
      " is",
      " important",
      " as",
      " the",
      " location",
      " of",
      " mult",
      "ide",
      "cade",
      " fin",
      "ch",
      " population",
      " studies",
      " by",
      " Peter",
      " and",
      " Rose",
      "mary",
      " Grant",
      ".",
      "\n",
      "-",
      " South",
      " Plaza",
      " Island",
      " (",
      "Pl",
      "aza",
      " Sur",
      ")",
      " –",
      " It",
      " is",
      " named",
      " in",
      " honor",
      " of",
      " a",
      " former",
      " president",
      " of",
      " Ecuador",
      ",",
      " General",
      " Leon",
      "idas",
      " Plaza",
      ".",
      " It",
      " has",
      " an",
      " area",
      " of",
      " 0",
      ".",
      "13",
      " km",
      "2",
      " (",
      "0",
      ".",
      "05",
      " sq",
      " mi",
      ")",
      " and",
      " a",
      " maximum",
      " altitude",
      " of",
      " 23",
      " m",
      " (",
      "75",
      " ft",
      ").",
      " The",
      " flora",
      " of",
      " South",
      " Plaza",
      " includes",
      " Op",
      "unt",
      "ia",
      " c",
      "actus",
      " and",
      " S",
      "es",
      "uv",
      "ium",
      " plants",
      ",",
      " which",
      " form",
      " a",
      " redd",
      "ish",
      " carpet",
      " on",
      " top",
      " of",
      " the",
      " lava",
      " formations",
      ".",
      " I",
      "gu",
      "anas",
      " (",
      "land",
      ",",
      " marine",
      " and",
      " some",
      " hybrids",
      " of",
      " both",
      " species",
      ")",
      " are",
      " abundant",
      ",",
      " and",
      " large",
      " numbers",
      " of",
      " birds",
      " can",
      " be",
      " observed",
      " from",
      " the",
      " cliffs",
      " at",
      " the",
      " southern",
      " part",
      " of",
      " the",
      " island",
      ",",
      " including",
      " trop",
      "ic",
      " birds",
      " and",
      " swallow",
      "-",
      "tailed",
      " gull",
      "s",
      ".",
      "\n",
      "-",
      " Nam",
      "eless",
      " Island",
      " –",
      " A",
      " small",
      " is",
      "let",
      " used",
      " mostly",
      " for",
      " sc",
      "uba",
      " diving",
      ".",
      "\n",
      "-",
      " R",
      "oca",
      " Red",
      "onda",
      " –",
      " An",
      " is",
      "let",
      " approximately",
      " 25",
      " km",
      " (",
      "16",
      " mi",
      ")",
      " northwest",
      " of",
      " Isabel",
      "a",
      ".",
      " Herman",
      " Mel",
      "ville",
      " dev",
      "otes",
      " the",
      " third",
      " and",
      " fourth",
      " sketches",
      " of",
      " The",
      " Enc",
      "ant",
      "adas",
      " to",
      " describing",
      " this",
      " is",
      "let",
      " (",
      "which",
      " he",
      " calls",
      ' "',
    ],
    activations: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.512, 0, 0,
      0.597, 0, 0.509, 0.799, 0, 0, 0, 0.542, 0, 0.437, 0.323, 0.206, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0.196, 0.343, 0, 0.271, 0.489, 0.483, 0.563, 0.23, 0.556, 0.427, 0.254, 0.294, 0.365,
      0.273, 0.338, 0.382, 0.545, 0.32, 0.883, 1.079, 0.966, 0.768, 0.753, 0, 0.232, 0, 0, 0, 0, 0,
      0, 0, 0, 0.326, 1.505, 0.449, 0.954, 1.08, 1.576, 0.863, 1.192, 1.705, 0.747, 1.068, 0.343, 0,
      0, 0, 0.664, 0, 0, 0.306, 0.361, 0, 0, 0, 0, 0, 0, 0.286, 0.352, 0, 0, 0.345, 0, 0, 0.324, 0,
      0.36, 0.449, 0, 0.3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.411,
      0.483, 0, 0, 0.545, 0, 0.521, 0.488, 0, 0.2, 0, 0, 0, 0.401, 0.341,
    ],
    normalizedActivations: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.29129538967786417, 0, 0, 0.3396549758548533, 0, 0.2895885807539704, 0.45458011006369825, 0,
      0, 0, 0.30836347891680155, 0, 0.2486251665805208, 0.18376642747255886, 0.11720087944070316, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.11151151636105738, 0.19514515363185042, 0,
      0.15418173945840077, 0.2782098545946789, 0.2747962367468914, 0.32031114138405764,
      0.13085535083185307, 0.31632858722830565, 0.242935803500875, 0.14450982222300293,
      0.16726727454158608, 0.20766175240707113, 0.15531961207432993, 0.19230047209202755,
      0.21733366964246897, 0.3100702878406953, 0.18205961854866512, 0.5023707599327228,
      0.6138822762937801, 0.5495924734937828, 0.4369430845167963, 0.4284090398973276, 0,
      0.13199322344778222, 0, 0, 0, 0, 0, 0, 0, 0, 0.18547323639645258, 0.8562491434866906,
      0.2554524022760957, 0.5427652377982078, 0.6144512126017448, 0.8966436213521757,
      0.4909920337734312, 0.6781720790937775, 0.9700364050796063, 0.4249954220495401,
      0.6076239769061699, 0.19514515363185042, 0, 0, 0, 0.37777370848848013, 0, 0,
      0.17409451023716102, 0.20538600717521283, 0, 0, 0, 0, 0, 0, 0.16271578407786944,
      0.20026558040353162, 0, 0, 0.19628302624777957, 0, 0, 0.18433536378052343, 0,
      0.20481707086724824, 0.2554524022760957, 0, 0.17068089238937353, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.23383282257344173, 0.2747962367468914, 0, 0,
      0.3100702878406953, 0, 0.2964158164495454, 0.2776409182867143, 0, 0.1137872615929157, 0, 0, 0,
      0.228143459493796, 0.19400728101592127,
    ],
    targetIdx: 188,
    absoluteTokenIdx: 6082236,
    modelId: "mini",
  },
];

export { Sample2032000 };
